import { render, staticRenderFns } from "./CostPerUnit.vue?vue&type=template&id=630f709a&scoped=true&"
import script from "./CostPerUnit.vue?vue&type=script&lang=js&"
export * from "./CostPerUnit.vue?vue&type=script&lang=js&"
import style0 from "./CostPerUnit.vue?vue&type=style&index=0&id=630f709a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f709a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VIcon,VLayout,VList,VListItem,VMenu,VSubheader})
